import { render } from "./ElectionStartView.vue?vue&type=template&id=c63c9098&ts=true"
import script from "./ElectionStartView.vue?vue&type=script&lang=ts"
export * from "./ElectionStartView.vue?vue&type=script&lang=ts"

import "./ElectionStartView.vue?vue&type=style&index=0&id=c63c9098&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__